<template>
  <div class="mgmt-item">
    <b-icon v-if="render && render == 'icon'" 
            :icon="getIcon(val)"
            :style="{ color: this.getIconColor(val) }"
            font-scale="1.0">
    </b-icon>

    <bar-graph  v-else-if="render && render == 'bar' && val"
                :thresholds="thresholds" 
                :val="val * 100" />

    <span v-else-if="render && render == 'numeric' && val">
      {{ getMarginText(val) || '&nbsp;' }}
    </span>

    <span v-else>
      {{ getValue(val) || '&nbsp;' }}
    </span>

    <b-icon v-if="render && render == 'med'" 
            icon="bag-plus-fill"
            style="color: black;"
            font-scale="1.0">
    </b-icon>
  </div>
</template>

<script>
import BarGraph from '@/components/CX/DashboardCards/BarGraph.vue';

export default {
  components: {
    BarGraph
  },

  props: {
    render: { type: String, default: undefined },
    val: { default: undefined },
    thresholds: { type: Array, required: true }
  },

  methods: {
    getIcon(value) {
      if(value === undefined)
        return;
      else if (value === '')
        return 'dash-circle'; // 'dash-circle-dotted';
      else if (value === false || value === 0)
        return 'x-circle-fill';
      else
        return 'check-circle-fill';
    },

    getIconColor(value) {
      if(value === undefined)
        return;
      else if (value === '')
        return '#999'; 
      else if (value === false || value === 0)
        return this.thresholds.find(s => s.Smiley == "frown-open")?.Color;
      else
        return this.thresholds.find(s => s.Smiley == "grin")?.Color;
    },

    getValue(value) {
      if (value === 0 || value === 0.0)
        return `${value}`;
      return value;
    },
    
    getMarginText(value){
      return value ? value.replace(',', '.') : null;
    }
  }
}
</script>
